var map = {
	".": [
		10,
		9
	],
	"./": [
		10,
		9
	],
	"./components/AtlasPage": [
		29,
		9,
		1,
		2,
		5,
		6,
		7
	],
	"./components/AtlasPage/": [
		29,
		9,
		1,
		2,
		5,
		6,
		7
	],
	"./components/AtlasPage/index": [
		29,
		9,
		1,
		2,
		5,
		6,
		7
	],
	"./components/AtlasPage/index.jsx": [
		29,
		9,
		1,
		2,
		5,
		6,
		7
	],
	"./components/AtlasPage/index.scss": [
		92,
		7,
		52
	],
	"./components/Checkbox": [
		17,
		9,
		20
	],
	"./components/Checkbox/": [
		17,
		9,
		20
	],
	"./components/Checkbox/index": [
		17,
		9,
		20
	],
	"./components/Checkbox/index.jsx": [
		17,
		9,
		20
	],
	"./components/Checkbox/index.scss": [
		84,
		7,
		53
	],
	"./components/DebugGrid": [
		37,
		9,
		27
	],
	"./components/DebugGrid/": [
		37,
		9,
		27
	],
	"./components/DebugGrid/index": [
		37,
		9,
		27
	],
	"./components/DebugGrid/index.jsx": [
		37,
		9,
		27
	],
	"./components/DebugGrid/index.scss": [
		100,
		7,
		54
	],
	"./components/DevelopmentPage": [
		30,
		9,
		0,
		11
	],
	"./components/DevelopmentPage/": [
		30,
		9,
		0,
		11
	],
	"./components/DevelopmentPage/index": [
		30,
		9,
		0,
		11
	],
	"./components/DevelopmentPage/index.jsx": [
		30,
		9,
		0,
		11
	],
	"./components/DevelopmentPage/index.scss": [
		94,
		7,
		55
	],
	"./components/DownloadsPage": [
		31,
		9,
		14
	],
	"./components/DownloadsPage/": [
		31,
		9,
		14
	],
	"./components/DownloadsPage/index": [
		31,
		9,
		14
	],
	"./components/DownloadsPage/index.jsx": [
		31,
		9,
		14
	],
	"./components/DownloadsPage/index.scss": [
		95,
		7,
		56
	],
	"./components/Footer": [
		27,
		9,
		0,
		28
	],
	"./components/Footer/": [
		27,
		9,
		0,
		28
	],
	"./components/Footer/index": [
		27,
		9,
		0,
		28
	],
	"./components/Footer/index.jsx": [
		27,
		9,
		0,
		28
	],
	"./components/Footer/index.scss": [
		90,
		7,
		57
	],
	"./components/GenomePage": [
		32,
		9,
		0,
		15
	],
	"./components/GenomePage/": [
		32,
		9,
		0,
		15
	],
	"./components/GenomePage/index": [
		32,
		9,
		0,
		15
	],
	"./components/GenomePage/index.jsx": [
		32,
		9,
		0,
		15
	],
	"./components/GenomePage/index.scss": [
		96,
		7,
		58
	],
	"./components/Header": [
		28,
		9,
		29
	],
	"./components/Header/": [
		28,
		9,
		29
	],
	"./components/Header/index": [
		28,
		9,
		29
	],
	"./components/Header/index.jsx": [
		28,
		9,
		29
	],
	"./components/Header/index.scss": [
		91,
		7,
		59
	],
	"./components/Headlines": [
		12,
		9,
		21
	],
	"./components/Headlines/": [
		12,
		9,
		21
	],
	"./components/Headlines/index": [
		12,
		9,
		21
	],
	"./components/Headlines/index.jsx": [
		12,
		9,
		21
	],
	"./components/Headlines/index.scss": [
		80,
		7,
		60
	],
	"./components/HistologyLayer": [
		20,
		9,
		1,
		5,
		3,
		13
	],
	"./components/HistologyLayer/": [
		20,
		9,
		1,
		5,
		3,
		13
	],
	"./components/HistologyLayer/index": [
		20,
		9,
		1,
		5,
		3,
		13
	],
	"./components/HistologyLayer/index.jsx": [
		20,
		9,
		1,
		5,
		3,
		13
	],
	"./components/HistologyLayer/index.scss": [
		85,
		7,
		61
	],
	"./components/HistologySection": [
		26,
		9,
		1,
		5,
		3,
		8
	],
	"./components/HistologySection/": [
		26,
		9,
		1,
		5,
		3,
		8
	],
	"./components/HistologySection/index": [
		26,
		9,
		1,
		5,
		3,
		8
	],
	"./components/HistologySection/index.jsx": [
		26,
		9,
		1,
		5,
		3,
		8
	],
	"./components/HistologySection/index.scss": [
		89,
		7,
		62
	],
	"./components/HistologyThumbnail": [
		21,
		9,
		31
	],
	"./components/HistologyThumbnail/": [
		21,
		9,
		31
	],
	"./components/HistologyThumbnail/index": [
		21,
		9,
		31
	],
	"./components/HistologyThumbnail/index.jsx": [
		21,
		9,
		31
	],
	"./components/Homepage": [
		33,
		9,
		0,
		12
	],
	"./components/Homepage/": [
		33,
		9,
		0,
		12
	],
	"./components/Homepage/index": [
		33,
		9,
		0,
		12
	],
	"./components/Homepage/index.jsx": [
		33,
		9,
		0,
		12
	],
	"./components/Homepage/index.scss": [
		97,
		7,
		63
	],
	"./components/Icon": [
		14,
		9,
		22
	],
	"./components/Icon/": [
		14,
		9,
		22
	],
	"./components/Icon/index": [
		14,
		9,
		22
	],
	"./components/Icon/index.jsx": [
		14,
		9,
		22
	],
	"./components/Icon/index.scss": [
		82,
		7,
		64
	],
	"./components/InfoPage": [
		34,
		9,
		0,
		16
	],
	"./components/InfoPage/": [
		34,
		9,
		0,
		16
	],
	"./components/InfoPage/index": [
		34,
		9,
		0,
		16
	],
	"./components/InfoPage/index.jsx": [
		34,
		9,
		0,
		16
	],
	"./components/InfoPage/index.scss": [
		98,
		7,
		65
	],
	"./components/Radio": [
		22,
		9,
		23
	],
	"./components/Radio/": [
		22,
		9,
		23
	],
	"./components/Radio/index": [
		22,
		9,
		23
	],
	"./components/Radio/index.jsx": [
		22,
		9,
		23
	],
	"./components/Radio/index.scss": [
		86,
		7,
		66
	],
	"./components/RegionMenu": [
		24,
		9,
		1,
		3,
		10
	],
	"./components/RegionMenu/": [
		24,
		9,
		1,
		3,
		10
	],
	"./components/RegionMenu/index": [
		24,
		9,
		1,
		3,
		10
	],
	"./components/RegionMenu/index.jsx": [
		24,
		9,
		1,
		3,
		10
	],
	"./components/RegionMenu/index.scss": [
		88,
		7,
		67
	],
	"./components/Slider": [
		15,
		9,
		24
	],
	"./components/Slider/": [
		15,
		9,
		24
	],
	"./components/Slider/index": [
		15,
		9,
		24
	],
	"./components/Slider/index.jsx": [
		15,
		9,
		24
	],
	"./components/Slider/index.scss": [
		83,
		7,
		68
	],
	"./components/TeamPage": [
		35,
		9,
		17
	],
	"./components/TeamPage/": [
		35,
		9,
		17
	],
	"./components/TeamPage/index": [
		35,
		9,
		17
	],
	"./components/TeamPage/index.jsx": [
		35,
		9,
		17
	],
	"./components/TeamPage/index.scss": [
		99,
		7,
		69
	],
	"./components/ThreeDMiniScene": [
		19,
		9,
		2,
		19
	],
	"./components/ThreeDMiniScene/": [
		19,
		9,
		2,
		19
	],
	"./components/ThreeDMiniScene/index": [
		19,
		9,
		2,
		19
	],
	"./components/ThreeDMiniScene/index.jsx": [
		19,
		9,
		2,
		19
	],
	"./components/ThreeDScene": [
		18,
		9,
		2,
		6,
		18
	],
	"./components/ThreeDScene/": [
		18,
		9,
		2,
		6,
		18
	],
	"./components/ThreeDScene/index": [
		18,
		9,
		2,
		6,
		18
	],
	"./components/ThreeDScene/index.jsx": [
		18,
		9,
		2,
		6,
		18
	],
	"./components/ThreeDSection": [
		25,
		9,
		1,
		2,
		6,
		3,
		9
	],
	"./components/ThreeDSection/": [
		25,
		9,
		1,
		2,
		6,
		3,
		9
	],
	"./components/ThreeDSection/index": [
		25,
		9,
		1,
		2,
		6,
		3,
		9
	],
	"./components/ThreeDSection/index.jsx": [
		25,
		9,
		1,
		2,
		6,
		3,
		9
	],
	"./components/Toggle": [
		13,
		9,
		25
	],
	"./components/Toggle/": [
		13,
		9,
		25
	],
	"./components/Toggle/index": [
		13,
		9,
		25
	],
	"./components/Toggle/index.jsx": [
		13,
		9,
		25
	],
	"./components/Toggle/index.scss": [
		81,
		7,
		70
	],
	"./components/Video": [
		23,
		9,
		26
	],
	"./components/Video/": [
		23,
		9,
		26
	],
	"./components/Video/index": [
		23,
		9,
		26
	],
	"./components/Video/index.jsx": [
		23,
		9,
		26
	],
	"./components/Video/index.scss": [
		87,
		7,
		71
	],
	"./data/body": [
		56,
		3,
		43
	],
	"./data/body-2021": [
		61,
		3,
		42
	],
	"./data/body-2021.json": [
		61,
		3,
		42
	],
	"./data/body.json": [
		56,
		3,
		43
	],
	"./data/brain": [
		55,
		3,
		45
	],
	"./data/brain-2021": [
		62,
		3,
		44
	],
	"./data/brain-2021.json": [
		62,
		3,
		44
	],
	"./data/brain.json": [
		55,
		3,
		45
	],
	"./data/config": [
		9,
		9
	],
	"./data/config.js": [
		9,
		9
	],
	"./data/content": [
		57,
		3,
		46
	],
	"./data/content.json": [
		57,
		3,
		46
	],
	"./index": [
		10,
		9
	],
	"./index.js": [
		10,
		9
	],
	"./layout": [
		16,
		9,
		0,
		4,
		30
	],
	"./layout/": [
		16,
		9,
		0,
		4,
		30
	],
	"./layout/_precompile-data.scss": [
		101,
		7,
		72
	],
	"./layout/_resets.scss": [
		102,
		7,
		73
	],
	"./layout/_typography.scss": [
		103,
		7,
		50
	],
	"./layout/base.scss": [
		93,
		7,
		51
	],
	"./layout/index": [
		16,
		9,
		0,
		4,
		30
	],
	"./layout/index.jsx": [
		16,
		9,
		0,
		4,
		30
	],
	"./pages/body": [
		63,
		9,
		0,
		1,
		2,
		5,
		32
	],
	"./pages/body.jsx": [
		63,
		9,
		0,
		1,
		2,
		5,
		32
	],
	"./pages/brain": [
		64,
		9,
		0,
		1,
		2,
		5,
		33
	],
	"./pages/brain.jsx": [
		64,
		9,
		0,
		1,
		2,
		5,
		33
	],
	"./pages/development": [
		65,
		9,
		0,
		4,
		34
	],
	"./pages/development.jsx": [
		65,
		9,
		0,
		4,
		34
	],
	"./pages/downloads": [
		66,
		9,
		0,
		4,
		36
	],
	"./pages/downloads.jsx": [
		66,
		9,
		0,
		4,
		36
	],
	"./pages/genome": [
		67,
		9,
		0,
		4,
		37
	],
	"./pages/genome.jsx": [
		67,
		9,
		0,
		4,
		37
	],
	"./pages/home": [
		68,
		9,
		0,
		4,
		35
	],
	"./pages/home.jsx": [
		68,
		9,
		0,
		4,
		35
	],
	"./pages/info": [
		69,
		9,
		0,
		4,
		38
	],
	"./pages/info.jsx": [
		69,
		9,
		0,
		4,
		38
	],
	"./pages/team": [
		70,
		9,
		0,
		4,
		39
	],
	"./pages/team.jsx": [
		70,
		9,
		0,
		4,
		39
	],
	"./util/BreakpointProvider": [
		11,
		9
	],
	"./util/BreakpointProvider.jsx": [
		11,
		9
	],
	"./util/CaptureImage": [
		58,
		9,
		41
	],
	"./util/CaptureImage.js": [
		58,
		9,
		41
	],
	"./util/MenuProvider": [
		54,
		9,
		1,
		3,
		40
	],
	"./util/MenuProvider.jsx": [
		54,
		9,
		1,
		3,
		40
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 79;
module.exports = webpackAsyncContext;